import { render, staticRenderFns } from "./ResolucionesNewOrEdit.vue?vue&type=template&id=3caca85e&scoped=true&"
import script from "./ResolucionesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ResolucionesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ResolucionesNewOrEdit.vue?vue&type=style&index=0&id=3caca85e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caca85e",
  null
  
)

export default component.exports